import {PAW_ENVELOPE_POSTER} from './pet-envelope.js?v=paw-video-v3';
import {previewPetOpening} from './pet-opening-preview.js?v=questionnaire-v1';
import {petGeneration} from './pet-portrait-generation.js?v=questionnaire-v1';
import {mountSharedPetGift} from './pet-gift.js?v=paw-video-v3';
import {validatePetPhoto, validatePetStep} from './pet-validation.js';
export {PET_PHOTO_MAX_BYTES, validatePetPhoto, validatePetStep} from './pet-validation.js';

if (typeof document !== 'undefined') {
  const root = document.getElementById('pet-birthday-app');
  if (root) {
    if (new URLSearchParams(location.search).has('gift')) mountSharedPetGift(root);
    else boot(root);
  }
}

function boot(root) {
  const generation = petGeneration(root), $ = id => document.getElementById(id);
  const data = {petType: '', petName: '', recipient: '', sender: '', message: '', openingStyle: 'paw-envelope'};
  let handoffNotice='';
  if(new URLSearchParams(location.search).get('from')==='digital-gift'){
    try{
      const draft=JSON.parse(sessionStorage.getItem('ivy-digital-pet-handoff-v1')||'null');
      if(draft&&draft.expires>Date.now()){
        if(generation?.hasRequest)handoffNotice='This tab already has a pet request. Use its controls to finish it or start another request.';
        else{
          for(const[key,max]of Object.entries({recipient:120,sender:120,message:400}))if(typeof draft[key]==='string')data[key]=draft[key].slice(0,max);
          if(['paw-envelope','direct'].includes(draft.openingStyle))data.openingStyle=draft.openingStyle;
          sessionStorage.removeItem('ivy-digital-pet-handoff-v1');
          handoffNotice='Your pet is the star. Start by uploading their photo; any birthday details you entered have been kept.';
        }
      }else sessionStorage.removeItem('ivy-digital-pet-handoff-v1');
    }catch{}
  }
  let step = 0, photo = null, photoUrl = '', uploadVersion = 0;
  const el = (tag, text, attrs = {}) => {
    const node = document.createElement(tag);
    if (text != null) node.textContent = text;
    for (const [name, value] of Object.entries(attrs)) node.setAttribute(name, value);
    return node;
  };
  const error = text => {$('pet-form-error').textContent = text;};
  function field(label, name, placeholder, max, textarea = false) {
    const wrap = el('label', label, {class: 'field'});
    const input = el(textarea ? 'textarea' : 'input', null, {name, maxlength: max, placeholder});
    if (!textarea) input.type = 'text';
    input.value = data[name]; wrap.append(input);
    if (textarea) wrap.append(el('span', `${data.message.length} / 240`, {class: 'pet-character-count', id: 'pet-message-count'}));
    return wrap;
  }
  async function usePhoto(file) {
    const version = ++uploadVersion, problem = validatePetPhoto(file);
    if (problem) {error(problem); return;}
    const url = URL.createObjectURL(file), image = new Image(); image.src = url;
    try {await image.decode(); if (image.naturalWidth < 200 || image.naturalHeight < 200) throw new Error('small');}
    catch {URL.revokeObjectURL(url); if (version === uploadVersion) error('Use a clear, readable photo at least 200 × 200 pixels.'); return;}
    if (version !== uploadVersion) {URL.revokeObjectURL(url); return;}
    if (photoUrl) URL.revokeObjectURL(photoUrl);
    photo = file; photoUrl = url; error(''); render(false);
  }
  function upload(q) {
    const zone = el('div', null, {class: photo ? 'pet-upload has-photo' : 'pet-upload'});
    const label = el('label', null, {class: 'pet-upload-label'});
    const input = el('input', null, {type: 'file', name: 'petPhoto', accept: 'image/jpeg,image/png,image/webp', 'aria-label': photo ? 'Replace pet photo' : 'Upload pet photo'});
    label.append(input);
    if (photo) label.append(el('img', null, {src: photoUrl, alt: 'Your uploaded pet photo'}));
    else label.append(el('span', '＋', {class: 'pet-upload-plus'}), el('strong', 'Add your pet’s photo'), el('span', 'or drop it here · JPG, PNG, WebP · up to 8 MB'));
    zone.append(label);
    if (photo) {
      const remove = el('button', 'Remove photo', {type: 'button', class: 'text-button pet-remove'});
      remove.addEventListener('click', () => {uploadVersion++; URL.revokeObjectURL(photoUrl); photo = null; photoUrl = ''; render(false);});
      zone.append(remove, el('p', 'Photo added · tap to replace it', {class: 'field-help'}));
    }
    input.addEventListener('change', () => {if (input.files[0]) usePhoto(input.files[0]);});
    for (const event of ['dragenter', 'dragover']) zone.addEventListener(event, e => {e.preventDefault(); zone.classList.add('dragover');});
    zone.addEventListener('dragleave', () => zone.classList.remove('dragover'));
    zone.addEventListener('drop', e => {
      e.preventDefault(); zone.classList.remove('dragover');
      if (e.dataTransfer.files.length !== 1) {error('Choose one pet photo for this birthday surprise.'); return;}
      usePhoto(e.dataTransfer.files[0]);
    });
    q.append(zone);
    const tips = el('details', null, {class: 'pet-photo-tips'});
    tips.append(el('summary', 'What makes a great pet photo?'));
    const list = el('ul');
    for (const text of ['One dog or cat in the photo.', 'Eyes, nose and mouth clearly visible, facing the camera.', 'Good light, with no blur or heavy filters.']) list.append(el('li', text));
    tips.append(list); q.append(tips);
  }
  function openingChoice(q) {
    const fieldset = el('fieldset', null, {class: 'pet-opening-choices'});
    fieldset.append(el('legend', 'Choose their opening'));
    const options = el('div', null, {class: 'pet-opening-options'});
    for (const [value, title, description] of [
      ['paw-envelope', 'Floral paw envelope', 'Tap the golden paw. Unwrap a little birthday magic.'],
      ['direct', 'Straight to the surprise', 'Go straight to their very own birthday singer.']
    ]) {
      const label = el('label', null, {class: 'pet-opening-card'}), radio = el('input', null, {type: 'radio', name: 'openingStyle', value});
      radio.checked = data.openingStyle === value;
      const art = el('span', value === 'direct' ? 'For you' : null, {class: 'pet-opening-art' + (value === 'direct' ? ' pet-opening-direct' : '')});
      if (value === 'paw-envelope') art.append(el('img', null, {src: PAW_ENVELOPE_POSTER, alt: '', loading: 'lazy'}));
      label.append(radio, art, el('span', title), el('small', description)); options.append(label);
    }
    fieldset.append(options); q.append(fieldset);
    const preview = el('button', 'Preview the envelope', {type: 'button', class: 'text-button pet-opening-preview-button'});
    preview.addEventListener('click', () => previewPetOpening(preview, photoUrl));
    q.append(preview, el('p', 'This preview uses the reusable opening only. Your own pet’s portrait and video come next.', {class: 'field-help'}));
    const summary = el('div', null, {class: 'pet-order-summary'});
    summary.append(el('strong', `For ${data.recipient}, from ${data.petName}`), el('p', 'One birthday portrait · one Happy Birthday video · one personal gift page'), el('p', 'No payment is collected in this test.', {class: 'field-help'}));
    q.append(summary);
  }
  function review(q) {
    if (generation?.hasRequest) {generation.mount(q, data, photo); return;}
    const card = el('div', null, {class: 'pet-review-card'});
    card.append(el('img', null, {src: photoUrl, alt: `${data.petName}, your birthday singer`}), el('p', `A birthday song from ${data.petName}`, {class: 'eyebrow'}), el('h3', `Happy Birthday, ${data.recipient}!`), el('p', 'Classic Happy Birthday · English · about 20 seconds', {class: 'pet-review-specs'}));
    if (data.message) card.append(el('p', data.message, {class: 'pet-review-message'}));
    card.append(el('p', `With love,\n${data.sender}`, {class: 'pet-review-signature'}), el('p', `Gift opening: ${data.openingStyle === 'paw-envelope' ? 'Floral paw envelope' : 'Straight to the surprise'}`, {class: 'pet-review-specs'}));
    q.append(card, el('p', 'Their name appears on the gift page. The song always sings “dear friend”.', {class: 'field-help'}));
    const edit = el('div', null, {class: 'pet-review-edit'});
    for (const [label, target] of [['Edit pet photo', 0], ['Edit birthday details', 1], ['Edit opening', 2]]) {
      const button = el('button', label, {type: 'button', class: 'text-button'});
      button.addEventListener('click', () => {step = target; render();}); edit.append(button);
    }
    q.append(edit, el('p', 'We’ll create a studio portrait with a birthday hat and a playful singing smile. Check it before we animate it.', {class: 'pet-concept-note'}));
    if (generation) generation.mount(q, {...data}, photo);
    else q.append(el('p', 'Generation is unavailable in this preview. Your photo has not been uploaded.', {class: 'field-help', role: 'status'}));
  }
  function progress(index) {
    $('pet-step-count').textContent = `STEP ${index + 1} OF 5`;
    const bar = root.querySelector('.pet-progress');
    bar.setAttribute('aria-valuenow', index + 1); bar.setAttribute('aria-valuetext', `Step ${index + 1} of 5`);
    bar.querySelectorAll('span').forEach((n, i) => n.classList.toggle('done', i <= index));
  }
  function render(focus = true) {
    const q = $('pet-question'); q.replaceChildren(); error(''); $('pet-back').disabled = step === 0; progress(step);
    const titles = ['Meet your birthday singer.', 'Who’s the birthday star?', 'Wrap their surprise.', 'Your birthday portrait.'];
    const descriptions = ['Start with one great photo. We’ll turn it into their birthday portrait.', 'A name, a little birthday wish, and who it’s from.', 'Choose how their gift begins. Try the envelope before you continue.', 'Check the details below. You approve their portrait before the song comes to life.'];
    q.append(el('h2', titles[step], {id: 'pet-question-title', tabindex: '-1'}), el('p', descriptions[step], {class: 'pet-step-description'}));
    if (step === 0) {
      if(handoffNotice)q.append(el('p',handoffNotice,{class:'pet-handoff-note'}));
      upload(q);
      const species = el('fieldset', null, {class: 'pet-species'}); species.append(el('legend', 'My pet is a…'));
      const options = el('div', null, {class: 'choices'});
      for (const value of ['Dog', 'Cat']) {
        const label = el('label', null, {class: 'choice'}), input = el('input', null, {type: 'radio', name: 'petType', value});
        input.checked = data.petType === value; label.append(input, el('span', value)); options.append(label);
      }
      species.append(options); q.append(species, field('What is your pet’s name?', 'petName', 'For example: Luna', 40));
    } else if (step === 1) {
      q.append(field('Who is it for?', 'recipient', 'For example: Mikey', 60), field('Your birthday message (optional)', 'message', 'A little birthday wish, in your own words.', 240, true), field('Signed by', 'sender', 'For example: Alex & Luna', 80), el('p', 'The song sings “dear friend”. Their name appears on the gift page.', {class: 'field-help'}));
    } else if (step === 2) openingChoice(q);
    else{if(handoffNotice&&generation?.hasRequest)q.append(el('p',handoffNotice,{class:'pet-handoff-note'}));review(q);}
    $('pet-next').hidden = step === 3; $('pet-next').disabled = step === 3;
    $('pet-next').textContent = step === 2 ? 'Review my surprise →' : 'Continue →';
    $('pet-save-note').textContent = step === 3 ? 'No payment is collected in this test.' : 'Your photo and answers stay in this tab.';
    if (focus) {$('pet-question-title').focus({preventScroll: true}); $('pet-question-title').scrollIntoView({block: 'start', behavior: 'instant'});}
  }
  root.addEventListener('pet:stage', e => {
    const video = ['queued', 'preparing', 'submitting', 'processing', 'completed'].includes(e.detail.state);
    progress(video ? 4 : 3);
    const title = $('pet-question-title'); if (title) title.textContent = video ? 'Your little birthday surprise.' : 'Your birthday portrait.';
    const description = root.querySelector('.pet-step-description');
    if (description) description.textContent = e.detail.state === 'completed' ? 'Your gift is ready. Open the full experience, or send their personal link.' : video ? 'We’re bringing your approved portrait to life with the classic Happy Birthday recording.' : 'Check and approve their portrait before we make the birthday video.';
    $('pet-save-note').textContent = video ? 'The song stays universal. Their name appears on the gift page.' : 'Check and approve your portrait before the video starts.';
  });
  $('pet-birthday-form').addEventListener('input', e => {
    const name = e.target.name;
    if (Object.hasOwn(data, name)) {data[name] = e.target.value; error(''); if (name === 'message') $('pet-message-count').textContent = `${data.message.length} / 240`;}
  });
  $('pet-birthday-form').addEventListener('submit', e => {
    e.preventDefault(); const problem = validatePetStep(step, data, photo);
    if (problem) {error(problem); return;}
    if (step < 3) {step++; render();}
  });
  $('pet-back').addEventListener('click', () => {if (step > 0) {step--; render();}});
  window.addEventListener('pagehide', () => {uploadVersion++; if (photoUrl) URL.revokeObjectURL(photoUrl);});
  if (generation?.hasRequest) step = 3;
  render(false);
}
